import {TicketWithFormattedSalePeriod} from '@wix/wix-events-commons-statics'
import {AnyAction} from 'redux'
import {changeEventAction} from '../actions/event'

export const tickets = (state: TicketWithFormattedSalePeriod[] = [], action: AnyAction) => {
  switch (action.type) {
    case changeEventAction.toString():
      return action.payload.tickets
    default:
      return state
  }
}
